import { render, staticRenderFns } from "./_base-toaster.vue?vue&type=template&id=5305052a&scoped=true"
import script from "./_base-toaster.vue?vue&type=script&lang=js"
export * from "./_base-toaster.vue?vue&type=script&lang=js"
import style0 from "./_base-toaster.vue?vue&type=style&index=0&id=5305052a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5305052a",
  null
  
)

export default component.exports